module.exports = __webpack_public_path__ + "static/media/explore 2.a079579f.svg";